import { toast } from "react-toastify";
import { HTTPURL } from "../../constants/Matcher";

export async function addSubUser(data) 
{
    try {
        const response = await fetch(HTTPURL + 'api/add-sub-user', {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(data)
        });
        const responseData = await response.json();
        if(responseData.status)
        {
            toast.success(responseData?.message);
        } else {
            toast.error(responseData?.message);
        }
        return responseData;
    } catch (error) {
        console.log(error.message);
        return error.message;
    }
}


// get all users
export async function sub_users_list(id) {
    try {
        const response = await fetch(HTTPURL + `api/get-sub-user/?registrar_id=${id}&registrar_role=${'Branches'}`);
        const responseData = await response.json();
        if(responseData.status)
        {
            // toast.success(responseData?.message);
        } else {
            toast.error(responseData?.message);
        }
        return responseData;
    } catch (error) {
        console.log(error.message);
        return error.message;
    }
}

// sub_users update 
export async function sub_users_update(id, data) {
    try {
        const response = await fetch(HTTPURL + `api/update-sub-users/?id=${id?.id}`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(data)
        });
        const responseData = await response.json();
        if (responseData.status) {
            toast.success(responseData?.message);
        } else {
            toast.error(responseData?.message);
        }
        return responseData;
    } catch (error) {
        console.log(error.message);
        return error.message;
    }
}


export async function sub_users_edit(id) {
    try {
        const response = await fetch(HTTPURL + `api/edit-sub-user?id=${id}`);
        const responseData = await response.json();
        if (responseData.status) {
            // toast.success(responseData?.message);
        } else {
            toast.error(responseData?.message);
        }
        return responseData;
    } catch (error) {
        console.log(error.message);
        return error.message;
    }
}


// user delete
export async function destroy_user(id,data) 
{
    try {
        const response = await fetch(HTTPURL + `api/users-destroy?id=${id}`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(data)
        });
        const responseData = await response.json();
        if(responseData.status)
        {
            toast.success(responseData?.message);
        } else {
            toast.error(responseData?.message);
        }
        return responseData;
    } catch (error) {
        console.log(error.message);
        return error.message;
    }
}